import activityTypes from 'helpers/enums/activityTypes'

const isActivityResponseEmpty = (type, draft) => {
	const mcqIsEmpty = draft => draft.value.length === 0
	const oeqIsEmpty = draft => !draft.value
	const activities = {
		[activityTypes.MULTIPLE_CHOICE_QUESTION]: mcqIsEmpty,
		[activityTypes.OPEN_ENDED_QUESTION]: oeqIsEmpty,
	}
	return activities[type] ? activities[type](draft) : false
}

export default isActivityResponseEmpty
